import { useEffect, useState } from "react";
import { EventModel } from "../../utilities/models/EventModel";

const UseEventLikesDislikesStatus = (event = EventModel) => {
  const [likes, setLikes] = useState(0);
  const [dislikes, setDislikes] = useState(0);
  const [thisUserLiked, setThisUserLiked] = useState(false);
  const [thisUserDisliked, setThisUserDisliked] = useState(false);

  useEffect(() => {
    // New DTO structure uses counts and currentUserReaction ('LIKE', 'DISLIKE', or null)
    setLikes(event?.likeCount ?? 0);
    setDislikes(event?.dislikeCount ?? 0);
    setThisUserLiked(event?.currentUserReaction === "LIKE");
    setThisUserDisliked(event?.currentUserReaction === "DISLIKE");
  }, [event]);

  return {
    likesDislikesStates: { likes, dislikes, thisUserLiked, thisUserDisliked },
    setLikesDislikesStates: {
      setLikes,
      setDislikes,
      setThisUserLiked,
      setThisUserDisliked,
    },
  };
};

export default UseEventLikesDislikesStatus;
